import React from "react";
import UpdateExec from "./executive/update";
import UpdateDesk from "./desk/update";
import { getCookie } from "../../utils";
import CONSTANT from "../../constant";

function DakList(props) {
  const user = getCookie(CONSTANT.cookie.userDetail);
  const { designationCode } = user;
  const { state } = props.history.location;
  const { details } = state;
  return designationCode === 370 ? (
    <UpdateDesk details={details} history={props.history} />
  ) : (
    <UpdateExec details={details} history={props.history} />
  );
}

export default DakList;
